export default "__VITE_ASSET__DJX$clvv__"